import React, { useCallback } from 'react';
import classNames from 'classnames';

import { EventBus } from 'src/common/EventBus';
import { Node } from 'src/common/interfaces/node.interface';
import { Step } from 'src/common/interfaces/step.interface';
import { TooltipComponent } from 'src/common/tooltip/component';
import { StepEditorContentConfigureStageTypeEnum } from 'src/editor/step-editor/content/configure/stage-type.enum';
import { useEditorNavigator } from 'src/editor/use-editor-navigator.hook';
import { UnionStrongIcon } from 'src/monet/icons';
import { useEditorContext } from 'src/store/editor';

interface Props {
  node: Node;
  step?: Step;
  className?: string;
}

const AddStepToSectionButton = ({ node, step, className = '' }: Props) => {
  const { setNodeToAddAfter } = useEditorContext();
  const { navigateToContentNew } = useEditorNavigator();

  const onAddStepBelowClicked = useCallback(
    (event) => {
      event.stopPropagation();
      EventBus.emit('editor:reset-stage', {
        showInitialStage: true,
        resetEditor: true,
        currentConfigurationStage: StepEditorContentConfigureStageTypeEnum.NEW,
      });
      if (step) {
        setNodeToAddAfter(node);
        navigateToContentNew(step.id);
      }
    },
    [step, setNodeToAddAfter, node, navigateToContentNew]
  );

  return (
    <div className={classNames('transition-opacity opacity-0 group-hover:opacity-100', className)}>
      <TooltipComponent tooltipContent='Add step' placement='top' theme='journey' styling='tooltip'>
        <div
          onClick={onAddStepBelowClicked}
          className='flex items-center justify-center bg-bedrock-black p-1 rounded-[20px] cursor-pointer has-hover'
        >
          <UnionStrongIcon className='text-bedrock-white' />
        </div>
      </TooltipComponent>
    </div>
  );
};

export default AddStepToSectionButton;
